import request from '@/api/request'

export default {
  async getColors () {
    return (await request.get(`module/action/marketplace/polishop/color`)).data
  },
  async getSizes () {
    return (await request.get(`module/action/marketplace/polishop/size`)).data
  },
  async getCategories () {
    return (await request.get(`module/action/marketplace/polishop/category/retrieve`)).data
  },
  async getBrands () {
    return (await request.get(`module/action/marketplace/polishop/brand/retrieve`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/polishop/index.js